import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twozerobusonrentinpune() {



  const cardData = {
"keyword": "20 Seater Bus on Rent in Pune",

"headingDescription":
  "Aaradhya Travels provides reliable 20 Seater Bus on Rent in Pune for family functions, corporate tours, wedding transportation, school trips, pilgrimage journeys, airport transfers, and outstation travel. Our spacious AC buses with professional drivers ensure comfortable, safe, and affordable group transportation across Pune and nearby tourist destinations.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description":
      "Lonavala is one of the most famous hill stations near Pune known for waterfalls, green valleys, Tiger Point, Bhushi Dam, caves, scenic highways, and monsoon tourism. Families, corporate groups, and tourists regularly hire 20 seater buses for weekend vacations, sightseeing tours, and comfortable group road trips from Pune."
  },
  {
    "title": "Khandala",
    "description":
      "Khandala is a beautiful hill destination famous for misty valleys, mountain landscapes, waterfalls, and peaceful surroundings. Group travelers often choose rental buses for comfortable travel and scenic road journeys through the Western Ghats."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a top tourist hill station known for strawberry farms, Venna Lake, waterfalls, mountain viewpoints, cool climate, and family tourism. 20 seater buses are highly preferred for family vacations, corporate outings, and sightseeing tours."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani is known for Table Land, scenic valleys, fresh air, strawberry farms, boarding schools, and relaxing hill station experiences. Travelers often book group buses for family holidays and educational trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba attracting devotees from across India. Families and religious groups commonly hire 20 seater buses for comfortable temple darshan and spiritual tours."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is famous for Trimbakeshwar Temple, vineyards, wine tourism, river ghats, and pilgrimage attractions. Bus travel from Pune is popular for religious journeys and sightseeing tours."
  },
  {
    "title": "Mumbai",
    "description":
      "Mumbai is known for Marine Drive, Gateway of India, beaches, shopping streets, Bollywood attractions, nightlife, and business hubs. Corporate teams and tourists regularly travel in rental buses from Pune to Mumbai."
  },
  {
    "title": "Goa",
    "description":
      "Goa is one of India’s most popular holiday destinations famous for beaches, churches, nightlife, seafood, resorts, and water sports. Friends groups and vacation travelers often hire buses for Goa road trips."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a scenic hill city near Pune known for lakeside roads, colorful buildings, cafes, and adventure activities. Group travelers frequently visit Lavasa for one-day picnics and corporate outings."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a historical hill fort near Pune known for trekking, panoramic mountain views, monsoon tourism, and Maratha history. Educational groups and tourists often choose buses for day tours."
  },
  {
    "title": "Aga Khan Palace",
    "description":
      "Aga Khan Palace is an important historical monument associated with Mahatma Gandhi and India’s freedom movement. Family groups and educational tours frequently visit this landmark in Pune."
  },
  
],



services: [
  {
    name: "20 Seater Bus on Rent in Pune",
    description: "20 seater bus on rent in Pune service provides spacious and comfortable transportation for family tours, corporate outings, airport transfers, wedding travel, educational trips, and outstation journeys. Well-maintained buses ensure smooth highway travel suitable for medium and large group transportation requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 20 seater bus reservations."
  },
  {
    name: "20 Seater Bus Rental in Pune for Outstation",
    description: "20 seater bus rental in Pune for outstation service offers reliable long-distance transportation for Goa trips, Shirdi darshan, Mahabaleshwar tours, Konkan travel, and family vacations. Spacious seating and luggage capacity ensure comfortable highway journeys suitable for tourist and pilgrimage groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "20 Seater Bus Rental in Pimpri Chinchwad",
    description: "20 seater bus rental in Pimpri Chinchwad service provides comfortable transportation for family outings, corporate travel, airport transfers, school trips, and outstation journeys. Spacious buses ensure smooth travel experiences suitable for group passengers and long-distance routes. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from residential societies, offices, hotels, and commercial locations across Pimpri Chinchwad. Flexible booking options allow convenient bus rental reservations."
  },
  {
    name: "20 Seater Mini Bus Hire in Pimpri Chinchwad",
    description: "20 seater mini bus hire in Pimpri Chinchwad service offers dependable transportation for office outings, family functions, educational tours, and tourist travel requirements. Comfortable seating and spacious interiors ensure pleasant travel experiences suitable for local and outstation group travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Pune to Mumbai Airport Mini Bus on Rent",
    description: "Pune to Mumbai Airport mini bus on rent service provides direct airport transportation for families, tourists, and corporate teams traveling between Pune and Mumbai Airport. Spacious vehicles ensure comfortable luggage handling and smooth expressway journeys suitable for group airport transfers. Professional chauffeurs ensure timely pickups and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and commercial locations across Pune. Flexible booking options allow convenient airport mini bus reservations."
  },
  {
    name: "Pune to Shirdi 20 Seater Mini Bus on Rent",
    description: "Pune to Shirdi 20 seater mini bus on rent service offers reliable transportation for Sai Baba darshan tours, family pilgrimages, and spiritual group travel from Pune. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi mini bus reservations."
  },
  {
    name: "20 Seater Bus for Corporate Events in Pune",
    description: "20 seater bus for corporate events in Pune service provides professional transportation for office meetings, conferences, employee travel, industrial visits, and company outings. Spacious buses ensure comfortable travel experiences suitable for executive teams and business passengers. Professional drivers ensure punctual pickup and safe driving services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "20 Seater Tempo Traveller Booking",
    description: "20 seater Tempo Traveller booking service provides spacious transportation for family vacations, sightseeing tours, airport transfers, wedding travel, and outstation journeys. Comfortable interiors and luggage capacity ensure smooth highway travel suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient traveller booking reservations."
  },
  {
    name: "Non AC 20 Seater Tempo Traveller in Pune",
    description: "Non AC 20 seater Tempo Traveller in Pune service offers economical transportation for educational trips, local sightseeing, family outings, and budget-friendly group travel requirements. Spacious seating ensures comfortable journeys suitable for short and long-distance travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC traveller reservations."
  },
  {
    name: "20 Seater Bus on Rent for Wedding in Pune",
    description: "20 seater bus on rent for wedding in Pune service provides luxurious transportation for wedding guests, family members, bridal parties, and event travel requirements. Comfortable seating and spacious interiors ensure smooth journeys suitable for marriage ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Pune to Shirdi 20 Seater Bus on Rent",
    description: "Pune to Shirdi 20 seater bus on rent service offers comfortable transportation for pilgrimage tours, family darshan trips, and spiritual journeys from Pune. Spacious buses ensure smooth highway travel suitable for devotees, tourist groups, and senior citizens. Professional drivers ensure safe driving and reliable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi bus reservations."
  },
  {
    name: "Pune to Lonavala 20 Seater Bus on Rent",
    description: "Pune to Lonavala 20 seater bus on rent service provides comfortable hill station transportation for picnic trips, sightseeing tours, corporate outings, and family vacations from Pune. Spacious buses ensure smooth expressway journeys suitable for tourists and group passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Lonavala bus reservations."
  },
  {
    name: "20 Seater Tempo Traveller Booking in Pune",
    description: "20 seater Tempo Traveller booking in Pune service offers dependable transportation for airport transfers, wedding travel, educational tours, family trips, and outstation journeys. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for group passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "20 Seater Bus on Rent in Pune Airport",
    description: "20 seater bus on rent in Pune Airport service provides direct airport transportation for tourists, business travelers, corporate groups, and family passengers arriving in Pune. Spacious buses ensure comfortable luggage handling and smooth local or outstation travel experiences. Professional drivers ensure timely airport pickup and dependable transportation services throughout the route. Pickup services are available directly from Pune Airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport bus reservations."
  },
  {
    name: "Pune to Hyderabad Tempo Traveller on Rent",
    description: "Pune to Hyderabad Tempo Traveller on rent service offers premium long-distance transportation for business travel, family vacations, corporate tours, and tourist journeys from Pune. Comfortable seating and luggage space ensure pleasant overnight highway travel suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the Hyderabad route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Hyderabad traveller reservations."
  },
  {
    name: "Pune to Konkan Darshan Tempo Traveller on Rent",
    description: "Pune to Konkan Darshan Tempo Traveller on rent service provides comfortable transportation for beach tourism, temple visits, family vacations, and sightseeing tours across Konkan destinations. Spacious vehicles ensure smooth highway journeys suitable for tourist and pilgrimage groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Konkan route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Konkan traveller reservations."
  },
  {
    name: "Mini Bus on Rent in Pune - Aaradhya Travels",
    description: "Mini bus on rent in Pune by Aaradhya Travels provides reliable transportation for local travel, airport transfers, educational tours, family functions, and outstation group journeys. Spacious seating and comfortable interiors ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "20 Seater Bus on Rent in Pimpri Chinchwad",
    description: "20 seater bus on rent in Pimpri Chinchwad service offers spacious transportation for office outings, wedding travel, educational tours, and family vacations. Comfortable seating and luggage capacity ensure smooth journeys suitable for local and outstation group travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "20 Seater Bus on Rent in Pimpri Chinchwad for Family",
    description: "20 seater bus on rent in Pimpri Chinchwad for family service provides comfortable transportation for family vacations, pilgrimage tours, weddings, picnics, and sightseeing journeys. Spacious interiors ensure pleasant travel experiences suitable for relatives and large family groups traveling together. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential societies across Pimpri Chinchwad Pune. Flexible booking options allow convenient family bus reservations."
  },
  {
    name: "Tempo Traveller on Rent in Pimpri Chinchwad",
    description: "Tempo Traveller on rent in Pimpri Chinchwad service provides dependable transportation for airport transfers, corporate travel, family outings, educational trips, and outstation journeys. Comfortable seating and spacious interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient traveller reservations."
  }
],

tableData: [
  ["20 Seater Bus on Rent in Pune", "20 Seater Bus Rental in Pune for Outstation"],
  ["20 Seater Bus Rental in Pimpri Chinchwad", "20 Seater Mini Bus Hire in Pimpri Chinchwad"],
  ["Pune to Mumbai Airport Mini Bus on Rent", "Pune to Shirdi 20 Seater Mini Bus on Rent"],
  ["20 Seater Bus for Corporate Events in Pune", "20 Seater Tempo Traveller Booking"],
  ["Non AC 20 Seater Tempo Traveller in Pune", "20 Seater Bus on Rent for Wedding in Pune"],
  ["Pune to Shirdi 20 Seater Bus on Rent", "Pune to Lonavala 20 Seater Bus on Rent"],
  ["20 Seater Tempo Traveller Booking in Pune", "20 Seater Bus on Rent in Pune Airport"],
  ["Pune to Hyderabad Tempo Traveller on Rent", "Pune to Konkan Darshan Tempo Traveller on Rent"],
  ["Mini Bus on Rent in Pune - Aaradhya Travels", "20 Seater Bus on Rent in Pimpri Chinchwad"],
  ["20 Seater Bus on Rent in Pimpri Chinchwad for Family", "Tempo Traveller on Rent in Pimpri Chinchwad"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 20 Seater Bus on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 20 seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family tours, corporate events, and group travel."
      },
      {
        WhyChooseheading: "Affordable 20 Seater Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 20 seater bus on rent in Pune with transparent pricing, flexible booking plans, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Pune",
        WhyChoosedescription: "Our 20 seater bus rental service in Pune operates 24 hours for airport transfers, weddings, school trips, corporate outings, outstation tours, and pilgrimage journeys."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC 20 Seater Buses",
        WhyChoosedescription: "All 20 seater buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "Flexible One Day & Multi-Day Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Perfect for Family & Corporate Group Travel",
        WhyChoosedescription: "The 20 seater bus is ideal for family vacations, office outings, wedding transportation, educational tours, tourist groups, and group sightseeing travel from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune Locations",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 20 seater bus on rent in Pune?", answer: "20 seater bus rental service in Pune provides comfortable group transportation for family trips, corporate travel, weddings, and outstation tours." },
    { question: "Is 20 seater bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 20 seater bus rental service in Pune." },
    { question: "Can I book 20 seater bus for outstation travel?", answer: "Yes, customers can book 20 seater buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide 20 seater buses for corporate events?", answer: "Yes, Aaradhya Travels provides 20 seater bus rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all 20 seater buses air-conditioned?", answer: "Yes, all 20 seater buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 20 seater bus online in Pune?", answer: "Yes, customers can easily book 20 seater bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious 20 seater buses suitable for weddings, family vacations, and group tours." },
    { question: "Are 20 seater bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 20 seater bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Gaikwad",
    feedback:
      "Managing transportation for our wedding guests was easy with a 20 Seater Bus on rent in Pune. The vehicle was comfortable, arrived as scheduled, and made group travel completely hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priyanka Jagtap",
    feedback:
      "We used a 20 Seater Bus rental in Pune for an educational tour and were very pleased with the service. The bus was spacious, well-maintained, and provided a pleasant travel experience for everyone.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "20 Seater Bus on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/20-seater-bus-on-rent-pune.jpg",
  "description": "Book 20 Seater Bus on rent in Pune with Aaradhya Travels for corporate events, airport transfers, weddings, family trips, and outstation travel. Affordable AC and Non-AC mini bus rental available for Shirdi, Mumbai, Pimpri Chinchwad, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3158"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/20-seater-bus-on-rent-in-pune"
  }
};




  return (
    <div>
      
<Helmet>
  <title>
    20 Seater Bus on Rent in Pune | Mini Bus Hire for Outstation | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 20 Seater Bus on rent in Pune with Aaradhya Travels. Affordable AC and Non-AC mini bus available for corporate travel, airport transfers, weddings, Shirdi trips, Mumbai travel, Pimpri Chinchwad rentals, and outstation tours."
  />

  <meta
    name="keywords"
    content="20 seater bus on rent in Pune, 20 seater bus rental in pune for Outstation, 20 seater bus rental in pimpri chinchwad, 20 seater Mini Bus Hire in Pimpri Chinchwad, pune to mumbai airport mini bus on rent, pune to shirdi 20 seater mini bus on rent, 20 seater bus for corporate events in pune, 20 seater tempo traveller booking, Non Ac seater tempo"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Twozerobusonrentinpune;